module.exports = __webpack_public_path__ + "static/img/qq-qun.aacca22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qq-qun.png
// module id = Qz6k
// module chunks = 11